import { useMediaQuery } from 'react-responsive';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
// Import your action creators
import { saveAmendmentData, setStep } from '../../redux/actions';

function AmendAdditional({ formId, selectedIndex, step }) {

  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const amendmentData = useSelector((state) => {
    const amendments = state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.amendments;
    return amendments?.[amendments.length - 1].amendmentData;
  });
    // const { token, user } = useAuth();
  const formData = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]); 

      // State hooks for form fields (assuming they are part of amendmentData)
  const [lastContractDate, setLastContractDate] = useState(amendmentData && amendmentData.lastContractDate);
  const [buyer1FirstName, setBuyer1FirstName] = useState(amendmentData && amendmentData.buyer1FirstName);
  const [buyer1LastName, setBuyer1LastName] = useState(amendmentData && amendmentData.buyer1LastName);
  const [buyer1Email, setBuyer1Email] = useState(formData?.data?.buyer1Email);
  const [buyer2FirstName, setBuyer2FirstName] = useState(amendmentData && amendmentData.buyer2FirstName);
  const [buyer2LastName, setBuyer2LastName] = useState(amendmentData && amendmentData.buyer2LastName);
  const [buyer2Email, setBuyer2Email] = useState(formData?.data?.tenants?.[0]?.tenantEmail);
  const [seller1Name, setSeller1Name] = useState(amendmentData && amendmentData.seller1Name); 
  const [seller2Name, setSeller2Name] = useState(amendmentData && amendmentData.seller2Name); 
  const [listingAgentName, setListingAgentName] = useState(amendmentData && amendmentData.listingAgentName); 
  const [listingAgentEmail, setListingAgentEmail] = useState(amendmentData && amendmentData.listingAgentEmail); 
  const [amendmentId, setAmendmentId] = useState(amendmentData && amendmentData.amendmentId);
  const [contractCompletionDate, setContractCompletionDate] = useState(amendmentData && amendmentData.contractCompletionDate);
//   const [amendmentDate, setAmendmentDate] = useState(amendmentData && amendmentData.amendmentDate);
  const [amendmentDate, setAmendmentDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(amendmentData && amendmentData.expirationDate);  
  const [currentDates, setCurrentDates] = useState(amendmentData && amendmentData.currentDates || {});
  const [newDates, setNewDates] = useState(amendmentData && amendmentData.newDates || {});
  const [otherDatesText, setOtherDatesText] = useState(amendmentData && amendmentData.otherDatesText);
  const [otherAmendmentsText, setOtherAmendmentsText] = useState(amendmentData && amendmentData.otherAmendmentsText);
//   const [sendToSeller, setSendToSeller] = useState(amendmentData?.sendToSeller === 'yes'); // Default to 'yes'
  const [sendToSeller, setSendToSeller] = useState('yes');
  const [packetDetails, setPacketDetails] = useState({});
  const [propertyDescription, setPropertyDescription] = useState(
    amendmentData?.propertyDescription || 
    formData?.propertyData?.data?.lotInfo?.legalDescription || 
    formData?.data?.propertyDescription
  );
  const [address, setAddress] = useState(amendmentData && amendmentData.address);
  const [county, setCounty] = useState(
    amendmentData?.county ||
    formData?.propertyData?.data?.ownerInfo?.mailAddress?.county ||
    formData?.data?.propertyCounty
  );
  const [selectedContract, setSelectedContract] = useState(selectedIndex);

    const prevStep = () => {
        handleSave(); // Save the amendment data before proceeding
        dispatch(setStep(step - 1)); // Dispatch action to update step in the Redux store
    };
    
    const nextStep = () => {
        handleSave(); // Save the amendment data before proceeding
        dispatch(setStep(step + 1)); // Ensure setStep returns a plain object     
    }; 

    // console.log("Send to Seller", sendToSeller);
    // console.log("Buyer 1 Email", buyer1Email, "Buyer 2 Email", buyer2Email);

    const handleSave = () => {
        const amendmentDateString = amendmentDate.toISOString();
        // Construct the amendmentData object from local state
        const updatedAmendmentData = {
          buyer1FirstName: buyer1FirstName,
          buyer1LastName: buyer1LastName,
          buyer1Email: buyer1Email,
          buyer2FirstName: buyer2FirstName,
          buyer2LastName: buyer2LastName,
          buyer2Email: buyer2Email,
          seller1Name: seller1Name, 
          seller2Name: seller2Name, 
          listingAgentName: listingAgentName,
          listingAgentEmail: listingAgentEmail,
          lastContractDate: lastContractDate,
          contractCompletionDate: contractCompletionDate,
          amendmentDate: amendmentDateString, 
          amendmentId: amendmentId,
          expirationDate: expirationDate,
          currentDates: currentDates,
          newDates: newDates,
          otherDatesText,
          otherAmendmentsText,
          sendToSeller: sendToSeller,
          packetDetails,
          propertyDescription: propertyDescription,
          address: address,
          county: county,
          selectedContract: selectedContract,
    
          // Include other fields as necessary
        };
        dispatch(saveAmendmentData(formId, updatedAmendmentData));
      };

    // const handleSendtoSellerCheckbox = (event) => {
    //     const newSendToSeller = event.target.checked ? 'yes' : 'no';
    //     setSendToSeller(newSendToSeller);
    // };
    const handleSendtoSellerCheckbox = (e) => {
        setSendToSeller(e.target.checked ? 'yes' : 'no');
      };


    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === "otherDatesText") {
        setOtherDatesText(value);
        } else if (name === "otherAmendmentsText") {
        setOtherAmendmentsText(value);
        }
    };
  

    const handleDateChange = (event) => {
        setExpirationDate(event.target.value);
    };

    return (
        <>
         <div className='overflow-y-auto max-h-[calc(100vh-375px)] w-[375px] md:w-[750px]'>
            <div className='flex flex-col justify-start px-4 w-full'>
                <div className='inline-flex justify-between w-[330px] md:w-full items-center'>
                    <h1 className='text-[14px] md:text-lg text-black font-[Inter] mb-2'>Other Amendments (Optional) & Send</h1>
                    {/* <button className='text-shi-green font-[Inter] text-[13px] md:text-lg ml-4 mb-2' onClick={handleSaveAmendment}>Save</button> */}
                </div>
                <h1 className='text-slate-700 font-[Inter] text-[12px] md:text-[16px] mb-6 w-[300px] md:w-[650px]'>These fields are optional, if you want to add any other amendments or dates not specified in the previous step.</h1>
            </div>

            <div className="flex flex-col text-left justify-start gap-2 items-start w-[330px] md:w-[750px] mb-6  px-6">
            <div className="w-[300px] md:w-[550px] mb-1 justify-start gap-2 items-start flex flex-col">
                <span className='text-sm text-slate-600'>
                    Other Dates in Contract
                </span>
            </div>
                <div className="w-[300px] md:w-[650px] py-1 px-3 h-[75px] md:h-[85px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex">
                    <input 
                        type="textarea"
                        name="otherDatesText"
                        placeholder="Other Contract Dates" 
                        className="text-left pl-2 w-[300px] md:w-[630px] h-full md:h-[75px]" 
                        value={otherDatesText}
                        onChange={handleChange}
                        required
                    />
                </div>    
            </div>

            <div className="flex flex-col text-left justify-start gap-2 items-start w-[330px] md:w-[750px] mb-6  px-6">
            <div className="w-[300px] md:w-[550px] mb-1 justify-start gap-2 items-start flex flex-col">
                <span className='text-sm text-slate-600'>
                    Additional Amendments
                </span>
            </div>
                <div className="w-[300px] md:w-[650px] py-1 px-3 h-[75px] md:h-[85px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex">
                    <input 
                        type="textarea"
                        name="otherAmendmentsText"
                        placeholder="Additional Amendments" 
                        className="text-left pl-2 w-[300px] md:w-[630px] h-full md:h-[75px]" 
                        value={otherAmendmentsText}
                        onChange={handleChange}
                        required
                    />
                </div>    
            </div>

            <div className="flex flex-col text-left justify-start gap-2 items-start w-[330px] md:w-[750px]  px-6">
            <div className="w-[330px] md:w-[550px] mb-1 justify-start gap-2 items-start flex flex-col">
                <span className='text-sm text-slate-600'>
                    Contract Expiration Date
                </span>
            </div>
                    <input 
                        type="date"
                        name="expirationDate"
                        className={`py-1 px-3 h-[39px] rounded-md border border-slate-200 w-[160px]`}
                        value={expirationDate || ""}
                        onChange={handleDateChange}
                        required
                    />
                </div>
            </div> 

            <div className="flex flex-col">
                <div className="w-[350px] md:w-[750px] mt-2 justify-start inline-flex  px-6">
                <input 
                    type="checkbox" 
                    onChange={handleSendtoSellerCheckbox} 
                    id="sendToSeller"
                    checked={sendToSeller === 'yes'}
                    value={sendToSeller}
                />
                <span className="pl-5 font-semibold w-[330px] md:w-full">Have Shishito manage e-signature?</span>
                </div>
            </div>

            <div className="flex w-full justify-center gap-10 md:gap-36 mt-4 bg-white">
                <button 
                    className={`w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-start flex`} 
                    onClick={prevStep}>
                    Back
                </button>
                <button 
                    className={`w-auto md:w-[150px] justify-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-start flex`}
                    onClick={nextStep} >
                    Sign and Send
                </button>
        </div>
        </>
    ); 
}

export default AmendAdditional;